export const SUBSCRIPTION_RESET_STATE = 'SUBSCRIPTION_RESET_STATE';
export const SUBSCRIPTION_CURRENT_ITEM = 'SUBSCRIPTION_CURRENT_ITEM';

export const SUBSCRIPTION_REQUEST_LOADING = 'SUBSCRIPTION_REQUEST_LOADING';
export const SUBSCRIPTION_REQUEST_SUCCESS = 'SUBSCRIPTION_REQUEST_SUCCESS';
export const SUBSCRIPTION_REQUEST_FAILED = 'SUBSCRIPTION_REQUEST_FAILED';

export const SUBSCRIPTION_CURRENT_ACTION = 'SUBSCRIPTION_CURRENT_ACTION';
export const SUBSCRIPTION_RESET_ACTION = 'SUBSCRIPTION_RESET_ACTION';